import { trimStart } from "lodash";
import { useEffect } from "react";
import ChatMpProvider from "@/core/data-provider/data-mp/chat/chat-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import {
  ChatState,
  messageSelector,
  ownMessageHistoryPositionSelector,
  setTooltipCommands,
  setTooltipCommandsOpen,
  setTooltipCommandsPosition,
  tooltipCommandsSelector,
} from "@/domains/chat/slice";
import { appliedChatSettingsSelector } from "@/domains/settings/chat/slice";

export default () => {
  const { showCommandTooltip } = useAppSelector(appliedChatSettingsSelector);
  const ownMessageHistoryPosition = useAppSelector(ownMessageHistoryPositionSelector);
  const message = useAppSelector(messageSelector);
  const tooltipCommands = useAppSelector((state) => tooltipCommandsSelector(state, message));
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!showCommandTooltip) {
      dispatch(setTooltipCommandsOpen(false));
      return;
    }

    if (ownMessageHistoryPosition === -1) {
      const trimmedMessage = trimStart(message);
      if (/^\/\S*\s*/.test(trimmedMessage)) {
        dispatch(setTooltipCommandsOpen(true));
      } else {
        dispatch(setTooltipCommandsOpen(false));
      }
    }
  }, [message, ownMessageHistoryPosition, dispatch, showCommandTooltip]);

  useEffect(() => {
    (async () => {
      const response = await ChatMpProvider.getCommands();
      if (response instanceof RpcMpProviderSuccessResponse) {
        const commands: ChatState["tooltipCommands"] = Object.entries(response.data.commands).map(
          ([key, value]) => ({
            value: key,
            ...value,
          }),
        );
        dispatch(setTooltipCommands(commands));
      } else {
        dispatch(setTooltipCommands([]));
      }
    })();
  }, [dispatch]);

  useEffect(() => {
    return () => {
      dispatch(setTooltipCommandsPosition(-1));
    };
  }, [tooltipCommands, dispatch]);
};
